import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=2cc43d16"
import script from "./MediaView.vue?vue&type=script&lang=js"
export * from "./MediaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports